import {ContentItem, EntryVisibility} from "../types/Entry";

export const shouldShowPaywall = (content: Array<ContentItem> | null, visibility: EntryVisibility): boolean =>
    !content && (visibility === "paid_only" || visibility === "members_only");
